import { render, staticRenderFns } from "./MaterialsJournalPage.vue?vue&type=template&id=460e71a4&scoped=true"
import script from "./MaterialsJournalPage.vue?vue&type=script&lang=js"
export * from "./MaterialsJournalPage.vue?vue&type=script&lang=js"
import style0 from "./MaterialsJournalPage.vue?vue&type=style&index=0&id=460e71a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e71a4",
  null
  
)

export default component.exports